export default function getFieldFactory() {
	return {
		getSourceField() {
			return {
				id:           'source',
				inputType:    'select',
				source:       'valueSource',
				label:        'Source',
				sourceName:   'name',
				sourceValue:  'value',
				value:        '',
				defaultValue: 'Select a source',
			};
		},
    getSourceSimpleField() {
      return {
        id:           'source',
        inputType:    'select',
        source:       'valueSourceSimple',
        label:        'Source',
        sourceName:   'name',
        sourceValue:  'value',
        value:        '',
        defaultValue: 'Select a source',
      };
    },
		getParametersField(label = 'Parameter') {
			return {
				id:           'parameters',
				inputType:    'select',
				label:        label,
				source:       'parameters',
				sourceName:   'name',
				sourceValue:  'name',
				value:        '',
				defaultValue: 'Select a parameter',
			};
		},
		getConditionalFields() {
			return [
				{
					id:           'conditionalTitle',
					inputType:    'p',
					label:        'Conditional Display',
					source:       '',
					sourceName:   '',
					sourceValue:  '',
					value:        '',
					defaultValue: '',
				},
				{
					id:           'conditionalDesc',
					inputType:    'small',
					label:        'You will need to add at least one custom parameter in order to use the conditional feature',
					source:       '',
					sourceName:   '',
					sourceValue:  '',
					value:        '',
					defaultValue: '',
					dependsField:      'parameters',
					dependsType:  'length',
					dependsValue: 0

				},
				getFieldFactory().getParametersField('Conditional Parameter'),
				{
					id:           'compare',
					inputType:    'select',
					source:       'compareTypesConditional',
					sourceName:   'name',
					sourceValue:  'value',
					value:        '',
					label:        'Compare',
					defaultValue: 'Select a comparison type',
					dynamic:      false,
					dependsField:  'parameters',
					dependsType:  'length',
					dependsValue: 1
				},
				{
					id:        'conditionalValue',
					inputType: 'input',
					value:     '',
					label:     'Conditional value',
					dynamic:   false,
					dependsField:      'parameters',
					dependsType:  'length',
					dependsValue: 1
				}
			]
		},
		getStripTagsField() {
			return {
				id: 'stripTags',
				inputType: 'select',
				source: 'yesNo',
				sourceName: 'name',
				sourceValue: 'value',
				value: '',
				label: 'Strip HTML tags',
				defaultValue: 'Select an option',
			}
		},
		getHideEmptyField() {
			return {
				id: 'hideEmpty',
				inputType: 'select',
				source: 'yesNo',
				sourceName: 'name',
				sourceValue: 'value',
				value: '',
				label: 'Hide empty',
				defaultValue: 'Select an option',
			}
		},
		getExtraFields() {
			return [
					this.getHideEmptyField(),
					this.getStripTagsField(),
					{
						id: 'trimText',
						inputType: 'select',
						source: 'yesNo',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Trim the text',
						defaultValue: 'Select an option',
					},
					...this.getConditionalFields(),
				];
		},
		getDynamicField() {
			return {
				id:           'dynamicValues',
				inputType:    'select',
				label:        'Dynamic Value',
				source:       'dynamicValues',
				sourceName:   'name',
				sourceValue:  'value',
				value:        '',
				defaultValue: 'Select a dynamic field',
			};
		},
		getValueInputType( inputType = 'input', label = 'Value' ) {
			return {
				id:        'value',
				inputType: inputType,
				value:     '',
				label:     label,
			};
		},
		getOnlyLabel( name, label ) {
			return {
				name:   name,
				label:  label,
				fields: [
					{
						id:           'field',
						inputType:    '',
						source:       '',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        '',
						defaultValue: '',
					}
				],
			}
		},
		getYesNoFieldGroup( name, label ) {
			return {
				name: name,
				label: label,
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'select',
						source: 'yesNo',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: label,
						defaultValue: 'Select an option',
					},
					getFieldFactory().getParametersField(),
				],
			};
		},
		getNewDefaultFieldGroup(name, label, fieldType = 'input', labelValue = 'Value') {
			return {
				name:   name,
				label:  label,
				fields: [
					this.getSourceField(), this.getValueInputType( fieldType, labelValue ), this.getParametersField(), this.getDynamicField(),
				],
			};
		},
    getNewDefaultFieldGroupForOutput(name, label, fieldType = 'input', labelValue = 'Value') {
      return {
        name:   name,
        label:  label,
        collapsed: false,
        order: 0,
        fields: [
          {
            id:           'field',
            inputType:    '',
            source:       '',
            sourceName:   'name',
            sourceValue:  'value',
            value:        '',
            label:        '',
            defaultValue: '',
          }
        ],
      };
    },
		getPostTypes(inputType) {
			return {
				name:   'post_type',
				label:  'Post type',
				fields: [
					this.getSourceField(), {
						id:           'value',
						inputType:    inputType,
						source:       'postTypes',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        'Value',
						defaultValue: 'Select a post type',
					}, this.getParametersField(),
				],
			}
		},
		getStatusFieldGroup(inputType) {
			return {
				name:   'post_status',
				label:  'Post status',
				fields: [
					this.getSourceField(), {
						id:           'value',
						inputType:    inputType,
						source:       'statuses',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        'Value',
						defaultValue: 'Select a status',
					}, this.getParametersField(),
				],
			}
		},
		getRolesFieldGroup(inputType, name = 'roles', label = 'Roles') {
			return {
				name:   name,
				label:  label,
				fields: [
					this.getSourceField(), {
						id:           'value',
						inputType:    inputType,
						source:       'roles',
						sourceName:   'name',
						sourceValue:  'value',
						value:        '',
						label:        'Value',
						defaultValue: 'Select a role',
					}, this.getParametersField(),
				],
			}
		}
	}
}
